import React from 'react';
import InboxCard from './InboxCard';
import HolidaysCard from './HolidaysCard';
import LeaveCard from './LeaveCard';
import RemoteCard from './RemoteCard';
import ExtraCard from './ExtraCard';

import SkeletonWithLoaders from 'components/common/Spinner';

function Dashboard() {

  return (
    <SkeletonWithLoaders>
    <div className="mt-5" data-tour="dashboard-main-card">
      <div className="row">
        {/* Left Column */}
        <div className="col-md-5">
          <div data-tour="dashboard-inbox-card"> <InboxCard /> </div>
        <div data-tour="holidays-card">
          <HolidaysCard />
          </div>  
        <div data-tour="dashboard-leave-card">
          <LeaveCard />
        </div>
        <div data-tour="remote-card">
          <RemoteCard />
        </div>
        </div>

        {/* Right Column */}
        <div className="col-md-7">
          <div data-tour="dashboard-extra-card">  <ExtraCard /> </div>
        </div>
      </div>
    </div>
    </SkeletonWithLoaders>
  );
}

export default Dashboard;